export enum UserFormNavigation {
    USER_PROFILE,
    COMPLY_SETTINGS,
    GROUPS,
    VOLUNTEER_AREAS,
    PAETEP_USER_ROLES,
    ACCOUNT_SECURITY,
}